import { render } from "./SitemapsView.vue?vue&type=template&id=c61dd49e"
import script from "./SitemapsView.vue?vue&type=script&lang=js"
export * from "./SitemapsView.vue?vue&type=script&lang=js"

import "./SitemapsView.vue?vue&type=style&index=0&id=c61dd49e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__